import * as React from "react"
import { Eye, EyeOff } from "lucide-react"
import { cn } from "@/lib/utils"
import { Input } from "./input"

const PasswordInput = React.forwardRef(({ className, ...props }, ref) => {
  const [visible, setVisible] = React.useState(false)

  const show = () => setVisible(true)
  const hide = () => setVisible(false)

  return (
    <div className="relative">
      <Input
        {...props}
        type={visible ? "text" : "password"}
        className={cn("pr-10", className)}
        ref={ref}
      />
      <button
        type="button"
        className="absolute inset-y-0 right-0 flex items-center px-3 text-muted-foreground/60 hover:text-foreground cursor-pointer select-none outline-none focus-visible:text-foreground"
        onMouseDown={show}
        onMouseUp={hide}
        onMouseLeave={hide}
        onTouchStart={show}
        onTouchEnd={hide}
        onKeyDown={(e) => {
          if (e.key === " " || e.key === "Enter") {
            e.preventDefault()
            show()
          }
        }}
        onKeyUp={(e) => {
          if (e.key === " " || e.key === "Enter") hide()
        }}
        tabIndex={0}
        aria-label="Show password while pressed"
        data-testid={
          props["data-testid"]
            ? `${props["data-testid"]}-eye`
            : "password-toggle"
        }
      >
        {visible ? (
          <EyeOff className="h-4 w-4" />
        ) : (
          <Eye className="h-4 w-4" />
        )}
      </button>
    </div>
  )
})
PasswordInput.displayName = "PasswordInput"

export { PasswordInput }
